module.exports = __webpack_public_path__ + "static/img/case-solution-diagram-05.05f688a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-solution-diagram-05.png
// module id = 77hR
// module chunks = 1